import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {pastMeeting} from '../../models/pastMeetingsModel';
import {pastList} from '../../models/pastMeetingsModel'
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {TableDialogComponent} from '../table-dialog/table-dialog.component';
import { Router } from '@angular/router';
import { MeetingDataSource } from 'src/app/service/meeting.datasource';
import { MatPaginator } from '@angular/material/paginator';
import { DashboardService } from 'src/app/service/dashboard.service';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { fromEvent, Observable } from 'rxjs';
import { MeetingService } from 'src/app/service/meeting.service';
import { PastMeetingDialogComponent } from '../past-meeting-dialog/past-meeting-dialog.component';
import { CopymeetingComponent } from '../copymeeting/copymeeting.component';
import { ScheduleMeetingPopupComponent } from '../schedule-meeting-popup/schedule-meeting-popup.component';
import { FollowupMeetingPopupComponent } from '../followup-meeting-popup/followup-meeting-popup.component';
import { DeleteMeetingPopupComponent } from '../delete-meeting-popup/delete-meeting-popup.component';
import { NotHeldPopupComponent } from '../not-held-popup/not-held-popup.component';
import { MomService } from 'src/app/service/mom.service';
import { PermissionService } from 'src/app/service/permission.service';

import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState
} from '@angular/cdk/layout';
import { Globals } from 'src/app/service/global';
import { UntypedFormControl } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { PreviousMeetingsComponent } from '../previous-meetings/previous-meetings.component';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilityService } from 'src/app/service/utility.service';
import { ConfidentialDialogComponent } from '../confidential-dialog/confidential-dialog.component';
import { environment, environment_const } from 'src/environments/environment';
import { ViewMomDialogComponent } from '../view-mom-dialog/view-mom-dialog.component';

@Component({
  selector: 'app-past-meetings',
  templateUrl: './past-meetings.component.html',
  styleUrls: ['./past-meetings.component.css']
})
export class PastMeetingsComponent implements OnInit {

  options: any
  today : any
  matDialogRef!: MatDialogRef<CopymeetingComponent>;
  matDialogDelete!: MatDialogRef<DeleteMeetingPopupComponent>;
  matDialogNotHeld!: MatDialogRef<NotHeldPopupComponent>;
  currentDate : any;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.Small
  )
  upcomingJson:any;
  
  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd! : boolean;

  @Input()
  deviceLg! : boolean;

  @Input()
  deviceXl! : boolean;

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;

  shown: 'native' | 'hover' | 'always' = 'native';
  // router: any;
  viewmom = "VIEW MOM";
  notheld = "NOT HELD";
  displayedColumns = ["meetingDate","meetingTitle","meetingAction","getdetails"];
  meetingDatasource!: MeetingDataSource;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('input', { static: true })
  input!: ElementRef;
  @ViewChild('start',{static : true, read: MatInput})
  startDa!: MatInput
  @ViewChild('end',{static:true, read: MatInput})
  endDa!: MatInput
  meetingJSON: any;
  isLoading:boolean = false;
  meetingInfoData: any;
  taskAssign: any = [];
  matDialogRefrence!: MatDialogRef<FollowupMeetingPopupComponent>;
  upcomingMeetingJson: any;
  agendaArray:any = [];
  byteData : any;
  showLoading = false;
  startFilterDate : any;
  endFilterDate : any;
  calendar = new UntypedFormControl();
  isShown: boolean = false ;
  constructor(public util:UtilityService,private permissionService:PermissionService, private spinner: NgxSpinnerService,private sideNav: SideNavServiceService,public sideNavService: SideNavServiceService,private globals:Globals,private readonly breakpointObserver: BreakpointObserver,private matDialog: MatDialog,private meetingService: MeetingService,private dialog : MatDialog,private router : Router, private dashboardService:DashboardService,private momService:MomService) {
    this.meetingJSON = {
      "delay": "10",
      "displayConfig": this.globals.settingValuesList.PAST_MEETING_CONF,
      "meetingStatus": [  
        27,20,677
      ],
      "startDelay": "10",
      "userId": localStorage.getItem("userId"),
      "startDate":"",
      "endDate":"",
      "visitorTimezone": JSON.parse(localStorage.getItem('currentUser') || '{}')['timeszone']
    }
  }
  ngOnInit(): void {
    this.options = {
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }
    this.isLoading = true;
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US",this.options);
    this.meetingDatasource = new MeetingDataSource(this.dashboardService);
    
    this.meetingJSON.page = 0;
    this.meetingJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
    this.meetingJSON.filterTxt = this.input.nativeElement.value;
    this.meetingJSON.filterCol = "meetingTitle";
    this.meetingDatasource.loadPastMeetings(this.meetingJSON);
  }

  ngOnChanges(){
    if((!this.deviceXl || !this.deviceLg) && this.sideNavService.returnExpandFullScreeBooleanSetter()){
      // this.sideNavService.expandFullScreenBooleanSetter(false,'past-card-container','panel-fullscreen')
    // }
    // this.sideNavService.expandFullScreenBooleanSetter(false,'task-card-container','panel-fullscreen')
    }
    else{
      // this.sideNavService.expandFullScreenBooleanSetter(false,'past-card-container','panel-fullscreen-mb-view')
    }
  }

  ngDoCheck(){
    if(this.deviceXl || this.deviceLg){
      this.displayedColumns = ["meetingDate","meetingTitle","meetingAction","getdetails"];
    }
    else if(this.deviceSm || this.deviceXs || this.deviceMd){
      this.displayedColumns = ["meetingDate","responsiveMeetingTitle","menu"];
    }
  }

  mom() {
    return this.router.navigate(['MoM'])
  }
  loadMeetingInfo(meeting:any){
    // this.spinner.show();
    if(meeting.isConfidential=='Y'){
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meeting,flag:true,viewMeetingTaskInfo:true}
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });

    }else{
      this.meetingService.fetchMeetingInfo(meeting.meetingId).subscribe(
        (meetingRes: any) => {
          // this.spinner.hide()
          this.meetingInfoData = meetingRes.body
          const d = this.dialog.open(TableDialogComponent, {
            data: this.meetingInfoData,
            panelClass: ['animate__animated','animate__slideInLeft'],
                    disableClose: true,
                    position : {
                      left : "0%"
                    },
                    maxWidth : "100vw",
                    maxHeight: "100vh",
                    width: "50%",
                    height : "100vh"
          })
          const mediumDialogSubscription = this.isMedium.subscribe(size => {
            if(size.matches){
              d.updateSize('70vw','100vh');
            }
          })
          const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
            if (size.matches) {
              d.updateSize('100vw', '100vh');
            } else {
              d.updateSize('50%', '100vh');
            }
          });
          const smallSubscription = this.isSmall.subscribe(size => {
            if(size.matches){
              d.updateSize('100vw', '100vh');
            }
          })
          d.afterClosed().subscribe(() => {
            smallDialogSubscription.unsubscribe();
            mediumDialogSubscription.unsubscribe();
            smallSubscription.unsubscribe()
          });
        },
        err => {
          //
          //this.ngxSpinner.hide();
        }).add(() => {
          //Called when operation is complete (both success and error)
        });
    }
    
  }

  redirectToMeeting(meeting:any){
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.MODIFY);
    if(!accessFlag){
      return;
    }
   if(meeting.isConfidential=="Y"){
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meeting,flag:true,meetingStartFlag:"N",showMoM : true}
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    // else if(meeting.momStatus == 'A'){
    //   this.router.navigate(['approvedMeeting'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meeting.meetingId, "showMoM" : true })}, skipLocationChange: true, replaceUrl: false });
    // }
    else{
      this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meeting.meetingId, "showMoM" : true })}, skipLocationChange: true, replaceUrl: false });  
    } 
  }

  openTable() {
    this.dialog.open(TableDialogComponent, {
      panelClass: ['table-outer-container'],
      maxWidth : "100%",
      width : "50%",
      maxHeight : "100vh",
      height : "60vh",
    })
  }
  ngAfterViewInit() {
  
    this.meetingDatasource.counter$
      .pipe(
        debounceTime(150),
                distinctUntilChanged(),
        tap((cnt) => {
          this.paginator.length = cnt;
        })
      )
      .subscribe();
      fromEvent(this.input.nativeElement,'keyup')
      .pipe(
          debounceTime(500),
          distinctUntilChanged(),
          tap(() => {
              this.loadPastMeetings();
          })
      )
      .subscribe();
    this.paginator.page
      .pipe(
        tap(() => this.loadPastMeetings())
      )
      .subscribe(); 
  }
  loadPastMeetings() {
    this.meetingJSON.page=this.paginator.pageIndex;
    this.meetingJSON.size=this.paginator.pageSize;
    this.meetingJSON.filterTxt = this.input.nativeElement.value;
    this.meetingJSON.filterCol = "meetingTitle";
    this.meetingDatasource.loadPastMeetings(this.meetingJSON);
  }

  copyMeeting(meeting:any){

    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.MODIFY);
    if(!accessFlag){
      return;
    }

    if(meeting.isConfidential=="Y"){
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meeting,copyMeeting:true}
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else{
    this.matDialogRef = this.dialog.open(CopymeetingComponent, {
      data:{meeting},
      panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: false,
      position : {
        left : "0%"
      },
      maxWidth: "100vw",           
      maxHeight: "100vh",
      width: "50%",
      height : "100vh"
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        this.matDialogRef.updateSize('70vw','100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogRef.updateSize('100vw', '100vh');
      } else {
        this.matDialogRef.updateSize('50%', '100vh');
      }
    });
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        this.matDialogRef.updateSize('100vw', '100vh');
      }
    })
    this.matDialogRef.afterClosed().subscribe((data)=>{
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['dashboard']);
      smallDialogSubscription.unsubscribe();
      mediumDialogSubscription.unsubscribe();
      smallSubscription.unsubscribe();
    });
  }
  }

  // method used to create Followup meeting from dashboard
  followupPopup(meetingInfo:any){
    this.matDialogRefrence = this.matDialog.open(FollowupMeetingPopupComponent, {
      data : {meetingData : meetingInfo},
      panelClass : "base-class-dialog",
      disableClose: false,
      maxWidth: "100%",
      maxHeight: "100vh",
      width : "50%"
    });
    this.matDialogRef.afterClosed().subscribe((data :any)=>
    { 

    });
  }

  deleteMeeting(meetingId:any){

    
    this.matDialogDelete = this.dialog.open(DeleteMeetingPopupComponent, {

      data:{meetingId},
      panelClass : "base-class-dialog",
      disableClose: false,
      maxWidth: "100%",
      maxHeight: "100vh",
      width : "50%"
    });
    this.matDialogRef.afterClosed().subscribe((data)=>{
      this.meetingDatasource.loadPastMeetings(this.meetingJSON);
    });

  }

  toggleFilter(filterName : any){
    let dateRangeFilter = <HTMLElement>document.getElementById('date-range-filter-pt');
    let searchFilter = <HTMLElement>document.getElementById('search-filter-pt');
    this.paginator.pageIndex = 0;
    switch(filterName){
      case "search":
        dateRangeFilter.hidden = true;
        searchFilter.hidden = false;
        break;
      case "oneWeek":
        // this.startFilterDate = new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() - 1) - 7));
        this.startFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 6);    
        this.endFilterDate =  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        var today = new Date();
        // var nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);

        this.isShown = true;
        // this.meetingJSON.startDate=new Date();
        // this.meetingJSON.endDate=this.endFilterDate;
        this.meetingJSON.startDate=this.startFilterDate;
        this.meetingJSON.endDate=this.endFilterDate;
        this.meetingJSON.idisplayStart=this.paginator.pageIndex;
        this.meetingJSON.idisplayLength=this.paginator.pageSize;
        this.meetingJSON.size=this.paginator.pageSize;

        this.meetingDatasource.loadPastMeetings(this.meetingJSON);      
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
      case "twoWeek":
        this.startFilterDate = new Date();    
        this.endFilterDate =  new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() - 1) + 6))

        this.isShown = true;
        this.meetingJSON.startDate=new Date();
        this.meetingJSON.endDate=this.endFilterDate;
        this.meetingJSON.idisplayStart=this.paginator.pageIndex;
        this.meetingJSON.idisplayLength=this.paginator.pageSize;
        this.meetingJSON.size=this.paginator.pageSize;

        this.meetingDatasource.loadPastMeetings(this.meetingJSON);
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
      case "nxtTwoWeek":
        this.startFilterDate = new Date();    
        this.endFilterDate =  new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() - 1) + 12))

        this.isShown = true;
        this.meetingJSON.startDate=new Date();
        this.meetingJSON.endDate=this.endFilterDate;
        this.meetingJSON.idisplayStart=this.paginator.pageIndex;
        this.meetingJSON.idisplayLength=this.paginator.pageSize;
        this.meetingJSON.size=this.paginator.pageSize;

        this.meetingDatasource.loadPastMeetings(this.meetingJSON);
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
      case "dateRange":
        // this.triggerRefresh()
        this.isShown = true;
        document.getElementById('calendar-click-icon-pt')?.click()
        this.startFilterDate = "";
        this.endFilterDate = "";
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
    }
  }

  openLinkMeeting(meetingInfo:any){
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.MODIFY);
    if(!accessFlag){
      return;
    }

    if(meetingInfo.isConfidential=="Y"){
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meetingInfo,linkMeetings:true}
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else{
    const previousDialog = this.dialog.open(PreviousMeetingsComponent,{
      data : {meetingResponse : meetingInfo},
      panelClass: ['animate__animated','animate__slideInLeft','rogowclass'],
      disableClose: false,
      position : {
        left : "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width : "50%",
      height : "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        previousDialog.updateSize('70vw','100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        previousDialog.updateSize('100vw', '100vh');
      } else {
        previousDialog.updateSize('50%', '100vh');
      }
    });
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        previousDialog.updateSize('100vw', '100vh');
      }
    })
    this.sideNav.dialogCheckedChecker(true)
    previousDialog.afterClosed().subscribe(() => {
      this.sideNav.dialogCheckedChecker(false)
      smallDialogSubscription.unsubscribe();
      smallSubscription.unsubscribe();
      mediumDialogSubscription.unsubscribe();
    });
    // let linkTabContainer = document.getElementById('link-tab-container');
    // let linkedTabContainer = document.getElementById('linked-tab-container');
    // linkTabContainer?.setAttribute('style','height: calc(100vh - 100px);width: 100%;overflow-y: auto;');
    // linkedTabContainer?.setAttribute('style','height: calc(100vh - 100px);width: 100%;overflow-y: auto;');
    }
  }

  notHeldPopup(meetingInfo:any){
      var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.MODIFY);
      if(!accessFlag){
        return;
      }

    if(meetingInfo.isConfidential=="Y"){
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meetingInfo,notHeldPop:true}
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else{
    this.matDialogNotHeld = this.dialog.open(NotHeldPopupComponent, {

      data:{
        meeting:meetingInfo
      },
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },                  
                  maxWidth: "100%",
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"

    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        this.matDialogNotHeld.updateSize('70vw','100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogNotHeld.updateSize('100vw', '100vh');
      } else {
        this.matDialogNotHeld.updateSize('50%', '100vh');
      }
    });
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        this.matDialogNotHeld.updateSize('100vw', '100vh');
      }
    })
    this.matDialogNotHeld.afterClosed().subscribe((data)=>{
      this.meetingDatasource.loadPastMeetings(this.meetingJSON);
      smallDialogSubscription.unsubscribe();
      mediumDialogSubscription.unsubscribe();
      smallSubscription.unsubscribe();
    });
  }
  }
  viewMomPdf_old(meetingInfoData:any){
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.MODIFY);
    if(!accessFlag){
      return;
    }
    this.agendaArray = [];
        var minuteJSON = {
            //"deletedFlag": 0,
            "meetingId": meetingInfoData.meetingId,
            "pkMomDetailId":meetingInfoData.pkMomDetailId,
            //"reviewType": "RA",
            //"orgCode": this.meetingInfoData.orgCode,
            "momStatus": environment_const.momApproveStatus,
            "userId":Number(this.globals.userId),
            "reportedUsersId": this.globals.userId+","+this.globals.repotingUsers,
            "fkMeetingEntityId": meetingInfoData.meetingId
          };
        this.showLoading = true;
        this.momService.viewMoM(minuteJSON).subscribe((response)=>{
          if(response.body!=null && response.body.length>0){
            
            // var byteArray = new Uint8Array(response.body[0].attachmentStream);
            
            // let file = new Blob([response.body[0].attachmentStream], { type: 'application/pdf' });            
            // this.byteData = file;
            // var blobUrl = URL.createObjectURL(file);
            // window.open(blobUrl);
          }
        }).add(()=>{
          this.showLoading = false;
        });
     // });
    
  }

  viewMomPdf(meetingInfoData:any){
    if(meetingInfoData.isConfidential=="Y"){
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meetingInfoData,viewMomPdfFlag:true}
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('70vw','100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if(size.matches){
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else{
    let viewMinutes = this.dialog.open(ViewMomDialogComponent,{
      data:{meetingInfo:meetingInfoData},
      panelClass: ['parent-dialog-container'],
      maxWidth : "100%",
      maxHeight : "100vh",
      minWidth : "80%",
      minHeight : "80vh",
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        viewMinutes.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        viewMinutes.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        viewMinutes.updateSize('100vw', '100vh');
      } 
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    viewMinutes.afterClosed().subscribe((data)=>{
      mediumDialogSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });
  }
  }

  triggerRefresh(num:number){
    if(num==0){
    this.input.nativeElement.value="";
    this.calendar.reset();
       this.startFilterDate = "";
       this.endFilterDate = "";
       this.meetingDatasource = new MeetingDataSource(this.dashboardService);
    this.meetingJSON.idisplayStart = 0;
    this.meetingJSON.idisplayLength = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
    this.meetingJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
    this.meetingJSON.filterTxt = this.input.nativeElement.value;
    this.meetingJSON.filterCol = "meetingTitle";
    this.meetingJSON.startDate="";
    this.meetingJSON.endDate="";
    this.meetingDatasource.loadPastMeetings(this.meetingJSON);
    this.refreshTabs();
    //this.isShownClose = ! this.isShownClose;
    this.toggleFilter('search')
   }
    else{
      this.meetingJSON.idisplayLength = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
      this.meetingJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
      this.meetingDatasource.loadPastMeetings(this.meetingJSON);
    }   
    // if(this.startFilterDate != "" && this.endFilterDate != ""){
    //   this.meetingDatasource = new MeetingDataSource(this.dashboardService)
    //   this.loadPastMeetings();
    //   this.refreshTabs();
    //   this.startDa.value = ''
    //   this.endDa.value = ''
    //   this.startDa.focus()
    //   this.calendar.reset()
    //   this.startFilterDate = "";
    //   this.endFilterDate = ""
    // }
  }
  triggerAlert(){
    this.isShown = true;
    this.meetingJSON.startDate=this.startFilterDate;
    this.meetingJSON.endDate=this.endFilterDate;
    this.meetingJSON.idisplayStart=this.paginator.pageIndex;
    this.meetingJSON.idisplayLength=this.paginator.pageSize;
    this.meetingJSON.size=this.paginator.pageSize;
    
    this.meetingDatasource.loadPastMeetings(this.meetingJSON);
  }
  refreshTabs(){
    this.meetingDatasource.counter$
      .pipe(
        tap((count) => {
          this.paginator.length = count;
        })
      )
      .subscribe();
      fromEvent(this.input.nativeElement,'keyup')
      .pipe(
          debounceTime(150),
          distinctUntilChanged(),
          tap(() => {
              this.loadPastMeetings();
          })
      )
      .subscribe();
    this.paginator.page
      .pipe(
        tap(() => this.loadPastMeetings())
      )
      .subscribe(); 
  }
}
